import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PsContext from "../../context";
import { IMAGES_512 } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const Announcements = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=announcement&upcoming=1")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          //  console.log(res["data"].data);
        }
        setLoader(false);
      });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee").start();
  };

  const getHtmlContent = (item) => {
    if (item.show_new_blink_img && item.show_new_blink_img == "1") {
      return `<div><img src=${IMAGES_512.NEW_GIF_10.default} /> ${item.content_html}</div>`;
    } else {
      return <div>{item.content_html}</div>;
    }
  };

  return (
    <div
      style={{
        borderRadius: "3px",
      }}
    >
      <div className="home-top-cour-desc">
        <Card>
          <img
            src="https://portal.tndls.ac.in/admin/files_list/dls/fm/Website/75_independance-300x104.png"
            className="border-bottom"
          />
          <Card.Body>
            <marquee
              direction="up"
              style={{ height: "700px" }}
              scrollAmount="3"
              onMouseOver={(e) => marqueeMouseOver()}
              onMouseOut={(e) => marqueeMouseOut()}
              id="adm_top_marquee"
            >
              {dataList.map((item) => {
                return (
                  <div
                    className="border-bottom py-2"
                    dangerouslySetInnerHTML={{
                      __html: getHtmlContent(item),
                    }}
                  />
                );
              })}
            </marquee>
          </Card.Body>
          <Card.Footer className="text-center bg-white">
            <Link to="/announcements-list">View All</Link>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default Announcements;
